import { state, zip, samePasswords, maxLengthSplit } from "@/utils/validations";
import withFormUtils from "./withFormUtils";
import { mapActions } from "vuex";

export default {
  mixins: [withFormUtils],

  methods: {
    validateState(value, allValues) {
      //temporary two variants of parsing due to
      //different fields format
      if (allValues.address_country || allValues.country) {
        return state(value, allValues.address_country || allValues.country);
      }
      return state(value);
    },

    validateZip(value, allValues) {
      if (allValues.address_country || allValues.country) {
        const country = allValues.address_country || allValues.country;
        return country === "US" ? zip(value) : "";
      }
    },

    checkPasswords(val, { password, password_repeat }) {
      if (password && password_repeat) {
        return samePasswords(password, password_repeat);
      }
    },

    validatePairStringLength(
      maxLength,
      firstFieldName,
      secondFieldName,
      formName = this.name,
      syncErrors = true
    ) {
      return (value, allValues) => {
        const {
          [firstFieldName]: firstFieldValue,
          [secondFieldName]: secondFieldValue
        } = allValues;
        if (firstFieldValue && secondFieldValue) {
          const firstField = this.getField(firstFieldName, formName);
          const secondField = this.getField(secondFieldName, formName);
          if (firstField.meta.blurred || secondField.meta.blurred) {
            const error = maxLengthSplit(maxLength)(
              firstFieldValue,
              secondFieldValue
            );
            let errorMessage = "";
            const firstFieldLabel = firstField.label;
            const secondFieldLabel = secondField.label;
            if (error && firstFieldLabel && secondFieldLabel) {
              errorMessage = `${firstFieldLabel} and ${secondFieldLabel} must be less than ${maxLength} characters (together)`;
            }
            //sync errors for pair fields
            if (syncErrors && errorMessage) {
              [firstFieldName, secondFieldName].forEach(field => {
                this.syncErrors({
                  formName,
                  fieldName: field,
                  errors: [errorMessage]
                });
              });
            }
            return errorMessage;
          }
        }
      };
    },

    ...mapActions("forms", ["syncErrors"])
  }
};
